'use strict';

/**
 * Activates the logout link under the user in the menu
 */
let setUpLogoutLink = function() {
	let logoutURL = '/code/views/ajax/users/logout.php';
	let logoutLink = $('a[href="/#logout"]');

	logoutLink.off('click');
	logoutLink.on('click', function() {
		logoutLink.html('<span>Logging Out</span> <i class="fa fa-cog fa-spin"></i>');
		$.ajax({
			type: 'POST',
			url: logoutURL,
			data: {},
			success: function() {
				window.location.href = '/login.html?origin_page=/home/';
			},
			error: function() {
				logoutLink.html('<span>Log Out Failed</span>');
			}
		});
		return false;
	});
};

/**
 * Updates the user name in the navigation
 */
let init = function(username) {
	let userDisplay;
	let $label = $('label[for="drop-username"]');

	$label.tooltip('dispose');

	if (username.length > 8) {
		userDisplay = username.substring(0, 8) + '...';
	} else {
		userDisplay = username;
	}

	$label.html('<span>' + userDisplay + '</span><i class="fas fa-chevron-down"></i>');
	$label.attr('data-toggle', 'tooltip').attr('data-placement', 'bottom');
	$label.attr('title', username).addClass('dark-tooltip');

	$label.tooltip();

	setUpLogoutLink();
};

module.exports = {
	init: init
};
